import { environment } from "../../../config/environment";
import { customFetch } from "../../../utils/Auth";

const API_BASE_URL = environment.apiUrl;

const makeApiCall = async (endpoint, options = {}) => {
  const response = await customFetch(`${API_BASE_URL}${endpoint}`, options);

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || `HTTP error! status: ${response.status}`
    );
  }

  return response.json();
};

export const fetchPipeline = () => makeApiCall("/flowline/pipeline");

export const fetchMetrics = (hours = 24, period = 60) =>
  makeApiCall(`/flowline/metrics?hours=${hours}&period=${period}`);
